<template>

  <div v-if="property.type=='list'"
       class="filters__body-section">
    <div :class="[collapsed ? 'collapsed':'expanded']"
         class="filter">
      <div class="filter__name">
        <div class="filter__name-text">{{ property.name }}</div>
        <button @click="collapsed = !collapsed"
                class="filter__control-button">
          <svg class="filter__control-button-icon" width="24" height="24" viewBox="0 0 24 24">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12 8.882l8.447 4.224-.894 1.788L12 11.118l-7.553 3.776-.894-1.788L12 8.882z"/>
          </svg>
        </button>
      </div>
      <div class="filter__body">
        <label
            v-for="(val, index) in property.property_values"
            :key="val.enum_id"

            :class="[index >= 5 && filter_more ? '': 'filter__check']"
            class="check check_small ">
          <input
              @change="changeValueFilter"
              v-model="val.checked"
              :checked="val.checked"
              :disabled="!val.available"
              :value="val.enum_id"
              type="checkbox" class="check__input">
          <span class="check__box"></span>
          <span class="check__label">{{ val.enum_value }}</span>
        </label>
        <button v-if="property.property_values.length >= 6"
                @click="changeFilterMore"
                class="filter__more">
          <span v-if="!filter_more">Показать ещё</span>
          <span v-else>Скрыть</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ByTypeList",
  data() {
    return {
      collapsed: false,
      filter_more: false,
    }
  },
  props: {
    'property': Object,
  },
  mounted() {

  },
  methods: {
    changeFilterMore(e) {
      this.filter_more = !this.filter_more
      if (!this.filter_more) {
        window.scrollTo({
          top: e.target.closest('div').offsetTop,
          behavior: 'smooth'
        });
      }
    },
    changeValueFilter(e){
      // console.log()
      window.url_helpers.set_filter_by_type(this.property.slug, (e.target.value), e.target.checked)
      this.$store.dispatch('group_info/CHANGE_CHECKED_FILTER', {
        property_id: this.property.property_id,
        slug: this.property.slug,
        checked: e.target.checked,
        enum_id: parseInt(e.target.value),
      })
    },
  },
}
</script>
